import { useState, useRef } from 'react';
import styles from './Tooltip.module.css';

function Tooltip({
  title,
  children,
  placement = "top"
}) {
  const [visible, setVisible] = useState(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });
  const triggerRef = useRef(null);

  const showTooltip = () => {
    if (triggerRef.current && title) {
      const rect = triggerRef.current.getBoundingClientRect();
      let top = 0;
      let left = 0;

      switch (placement) {
        case 'top':
          top = rect.top - 8;
          left = rect.left + rect.width / 2;
          break;
        case 'bottom':
          top = rect.top + 8;
          left = rect.left + rect.width / 2;
          break;
        case 'left':
          top = rect.top + rect.height / 2;
          left = rect.left - 8;
          break;
        case 'right':
          top = rect.top + rect.height / 2;
          left = rect.right + 8;
          break;
        default:
          top = rect.top - 8;
          left = rect.left + rect.width / 2;
      }

      setPosition({ top, left });
      setVisible(true);
    }
  };

  const hideTooltip = () => {
    setVisible(false);
  };

  return (
    <>
      <div
        className={styles.trigger}
        aria-describedby={title}
        ref={triggerRef}
        onMouseEnter={showTooltip}
        onMouseLeave={hideTooltip}>
        {children}
      </div>
      {visible && title && (
        <div
          role="tooltip"
          className={[
            styles.tooltip,
            styles[placement],
            styles.visible
          ].join(" ")}
          style={{
            position: "fixed",
            top: `${position.top}px`,
            left: `${position.left}px`
          }}
        >
          {title}
        </div>
      )}
    </>
  );
}

export default Tooltip;